import {
    FETCH_EVENTS,
    FETCH_EVENTS_FAIL,
    FETCH_EVENTS_SUCCESS,
    RESET_EVENTS
} from './actionTypes';
import {
    defaultFirstPage,
    defaultItemsPerPage
} from '../../../../../services/Paging';

const initialState = {
    data: [],
    eventCategory: '',
    pagination: {
        pageSize: defaultItemsPerPage,
        page: defaultFirstPage,
        hasNextPage: false
    },
    sort: {
        sortType: 'EVENT_TIMESTAMP',
        sortOrder: 'DESC'
    },
    error: null,
    loading: false,
    loaded: false
};

export function eventsReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_EVENTS: {
            const { eventCategory, sort, pagination } = action.payload;

            return {
                ...initialState,
                eventCategory,
                sort: {
                    ...state.sort,
                    ...sort
                },
                pagination: {
                    ...state.pagination,
                    ...pagination
                },
                loading: true,
                loaded: false
            };
        }
        case FETCH_EVENTS_SUCCESS: {
            return {
                ...state,
                data: action.payload.result,
                pagination: {
                    ...state.pagination,
                    hasNextPage: action.payload.hasNext
                },
                loaded: true,
                loading: false
            };
        }
        case FETCH_EVENTS_FAIL: {
            return {
                ...initialState,
                error: action.payload
            };
        }
        case RESET_EVENTS: {
            return initialState;
        }
        default:
            return state;
    }
}
